import { FadeIn, MaskedLine } from "./Reveal";

export const Intro = () => (
  <section
    id="intro"
    data-testid="intro-section"
    className="relative mx-auto max-w-[1600px] px-6 pt-32 pb-6 sm:px-10 sm:pt-44 sm:pb-8 lg:px-16 lg:pt-56 lg:pb-10"
  >
    <div className="pointer-events-none absolute -top-6 right-0 hidden h-72 w-56 bg-butter/40 lg:block" />
    <h2 className="relative z-10 font-serif font-light leading-[1.04] text-ink text-[clamp(1.17rem,3.24vw,3.06rem)]">
      <MaskedLine delay={0.1}>WE CREATE</MaskedLine>
      <MaskedLine delay={0.25}>
        MOMENTS <span className="italic text-olive">worth</span>
      </MaskedLine>
      <MaskedLine delay={0.4}>REMEMBERING.</MaskedLine>
    </h2>
    <div className="mt-20 grid grid-cols-1 lg:grid-cols-12">
      <FadeIn delay={0.2} className="lg:col-span-5 lg:col-start-8">
        <p className="text-base font-light leading-relaxed text-ink/80 sm:text-lg">
          “We are a Dubai based experiential agency crafting beautiful brand
          launches, corporate gatherings and private events. From the first
          idea to the final detail, we bring together thoughtful planning,
          creative direction and impeccable execution.”
        </p>
        <div className="mt-10 h-px w-24 bg-olive/50" />
      </FadeIn>
    </div>
  </section>
);
